import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
    signal,
} from '@angular/core';
import {
    ArrowKeysItemDirective,
    ArrowKeysListDirective,
} from '@interacta-shared/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { UserMenuLanguage } from '../../../models/user-menu.model';
import { UserMenuButtonComponent } from '../user-menu-button/user-menu-button.component';
import { UserMenuSeparatorComponent } from '../user-menu-separator/user-menu-separator.component';
import { UserMenuTitleComponent } from '../user-menu-title/user-menu-title.component';

@Component({
    selector: 'interacta-user-menu-language',
    templateUrl: './user-menu-language.component.html',
    imports: [
        TranslatePipe,
        UserMenuButtonComponent,
        UserMenuSeparatorComponent,
        UserMenuTitleComponent,
        ArrowKeysListDirective,
        ArrowKeysItemDirective,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuLanguageComponent {
    readonly availableLanguages = input.required<UserMenuLanguage[]>();
    readonly currentLanguage = input.required<UserMenuLanguage>();

    readonly changeLanguage = output<UserMenuLanguage>();
    readonly back = output<void>();

    readonly currentIndex = signal(0);
}
